export function getButtonId(tipo, step) {
  const buttonIds = {
    platinum: {
      '/1': '2023_WILDFI_TCPlatinum_Click_Siguiente_Paso_1',
      '/summary': '2023_WILDFI_TCPlatinum_Click_Terminar',
      '/success': '2023_WILDFI_GA4_TCPlatinum_Paso_final',
    },
  };

  if (tipo in buttonIds) {
    return buttonIds[tipo][step];
  }

  return '';
}

export function getParameters() {
  const urlObj = new URL(window.location.href);
  const parametros = {};

  // Iterar sobre los parámetros y agregarlos al objeto
  urlObj.searchParams.forEach((valor, clave) => {
    parametros[clave] = valor;
  });

  return parametros;
}
